/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;



//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi/~/lodash/_baseIsNaN.js
// module id = ./node_modules/victory-voronoi/node_modules/lodash/_baseIsNaN.js
// module chunks = 1